import { Injectable } from '@angular/core';
import { SensorModel } from '../models/sensor.model';
import { CustomEntity } from '../models/customEntity.model';
import { TranslateService } from './translate.service';

@Injectable({
    providedIn: 'root'
})
export class BatteryService {
    constructor(private translateService: TranslateService) {}
    getBatteryImgSrcs(entity: SensorModel | CustomEntity): string[] {
        if (this.isSensorModel(entity)) {
            return this.getBatteryImgSrcsCommon(entity.batteryPercentage, entity.batteryCharging);
        } 
        
        if (this.isCustomEntity(entity)) {
            if (!entity.devices || entity.devices.length === 0) {
                return ['./assets/images/error-battery-status.svg'];
            }

            return entity.devices.flatMap(device => 
                this.getBatteryImgSrcsCommon(device.batteryPercentage, device.batteryCharging)
            );
        }

        return ['./assets/images/error-battery-status.svg'];
    }

    getBatteryTooltips(entity: SensorModel | CustomEntity): string[] {
        if (this.isSensorModel(entity)) {
            return this.getBatteryTooltipsCommon(entity.batteryPercentage, entity.batteryCharging);
        } 
        
        if (this.isCustomEntity(entity)) {
            if (!entity.devices || entity.devices.length === 0) {
                return [this.translateService.getDynamicTranslation('No devices available')];
            }

            return entity.devices.flatMap(device => 
                this.getBatteryTooltipsCommon(device.batteryPercentage, device.batteryCharging)
            );
        }

        return [this.translateService.getDynamicTranslation('No battery information available')];
    }

    getBatteryImgSrcsCommon(batteryPercentage: number | null, batteryCharging: boolean | null): string[] {
        if (batteryPercentage === null || batteryCharging === null) {
            return ['./assets/images/error-battery-status.svg'];
        }

        if (batteryCharging) {
            return ['./assets/images/charging-battery-status.svg'];
        } else if (batteryPercentage < 30) {
            return ['./assets/images/low-battery-status.svg'];
        } else if (batteryPercentage > 75) {
            return ['./assets/images/full-battery-status.svg'];
        } else {
            return ['./assets/images/mid-battery-status.svg'];
        }
    }

    getBatteryTooltipsCommon(batteryPercentage: number | null, batteryCharging: boolean | null): string[] {
        if (batteryPercentage === null || batteryCharging === null) {
            return [this.translateService.getDynamicTranslation('No battery information available')];
        }

        const chargingText = batteryCharging ? ` (${this.translateService.getDynamicTranslation('Charging')})` : '';
        return [this.translateService.getDynamicTranslation('Battery: {{percentage}}%{{charging}}', { percentage: batteryPercentage, charging: chargingText })];
    }

    private isSensorModel(entity: SensorModel | CustomEntity): entity is SensorModel {
        return (entity as SensorModel).batteryPercentage !== undefined && (entity as SensorModel).batteryCharging !== undefined;
    }

    private isCustomEntity(entity: SensorModel | CustomEntity): entity is CustomEntity {
        return (entity as CustomEntity).devices !== undefined;
    }
}